// Do not change order
export enum EventStatus {
  UPCOMING = 'upcoming',
  PREGAME = 'pregame',
  RUNNING = 'running',
  FIRST_HALF = 'fh',
  FIRST_HALF_PAUSE = 'htpause',
  HT_RUNNING = 'ht_running',
  SECOND_HALF = 'sh',
  SECOND_HALF_PAUSE = 'shpause',
  OT_FIRST_HALF = 'otfh',
  OT_FIRST_HALF_PAUSE = 'otpause',
  OT_SECOND_HALF = 'otsh',
  PENALTY_SHOOTOUT = 'ps',
  POST_GAME = 'postgame',
  ENDED = 'ended',
  CANCELLED = 'cancelled',
  ABORTED = 'aborted',
}

export const PreGamePhases = [EventStatus.PREGAME, EventStatus.UPCOMING];
export const InGamePhases = [
  EventStatus.FIRST_HALF,
  EventStatus.FIRST_HALF_PAUSE,
  EventStatus.SECOND_HALF,
  EventStatus.SECOND_HALF_PAUSE,
  EventStatus.OT_FIRST_HALF,
  EventStatus.OT_FIRST_HALF_PAUSE,
  EventStatus.OT_SECOND_HALF,
  EventStatus.PENALTY_SHOOTOUT,
];
export const PostGameAndCancelledPhases = [
  EventStatus.POST_GAME,
  EventStatus.ENDED,
  EventStatus.ABORTED,
  EventStatus.CANCELLED,
];
export const AutoPhases = [EventStatus.RUNNING, EventStatus.HT_RUNNING];

export enum EventStatusString {
  CREATED = 'Spiel wurde erstellt',
  UPCOMING = 'Vor dem Spiel',
  RUNNING = 'Nach Spielbeginn',
  START = 'Spielbeginn',
  FIRST_HALF = '1. Halbzeit',
  FIRST_HALF_PAUSE = 'Halbzeit',
  HT_RUNNING = 'Nach der Halbzeit',
  SECOND_HALF = '2. Halbzeit',
  SECOND_HALF_PAUSE = 'Halbzeit vor VL',
  OT_FIRST_HALF = '1. HZ VL',
  OT_FIRST_HALF_PAUSE = 'Halbzeit VL',
  OT_SECOND_HALF = '2. HZ VL',
  PENALTY_SHOOTOUT = 'Elfmeter',
  POST_GAME = 'Nach dem Spiel',
  END = 'Spielende',
  EVENT_CLOSED = 'Beendet',
  NOT_MODERATED = 'Spiel wurde nicht moderiert!',
  ABORTED = 'Abgebrochen',
  CANCELLED = 'Abgesagt',
}

export enum ShortEventStatusString {
  Upcoming = 'Vor dem Spiel',
  Pregame = 'In Kürze',
  FirstHalf = '1. HZ',
  FirstHalfPause = 'Halbzeit',
  SecondHalf = '2. HZ',
  SecondHalfPause = 'Halbzeit vor VL',
  OtFirstHalf = '1. HZ VL',
  OtFirstHalfPause = 'Halbzeit VL',
  OtSecondHalf = '2. HZ VL',
  PenaltyShootout = 'Elfmeter',
  PostGame = 'Endstand',
  End = 'Endstand',
  Aborted = 'Abgebrochen',
  Cancelled = 'Abgesagt',
}

export enum EventStatusStringEN {
  CREATED = 'Match Created',
  UPCOMING = 'Before Match Start',
  RUNNING = '1st Half',
  START = '1st Half',
  FIRST_HALF = '1st Half',
  FIRST_HALF_PAUSE = 'Halftime',
  HT_RUNNING = '2nd Half',
  SECOND_HALF = '2nd Half',
  SECOND_HALF_PAUSE = 'Extra-Time: Break',
  OT_FIRST_HALF = 'Extra-Time: 1st Half',
  OT_FIRST_HALF_PAUSE = 'Extra-Time: Halftime',
  OT_SECOND_HALF = 'Extra-Time: 2nd Half',
  PENALTY_SHOOTOUT = 'Penalties',
  POST_GAME = 'Match Ended',
  END = 'Match Ended',
  EVENT_CLOSED = 'Match Ended',
  NOT_MODERATED = 'Not moderated',
  ABORTED = 'Match Aborted',
  CANCELLED = 'Match Cancelled',
}

export const EventStatusStringMap = new Map<
  EventStatus | string,
  EventStatusString
>([
  [EventStatus.UPCOMING, EventStatusString.UPCOMING],
  [EventStatus.PREGAME, EventStatusString.UPCOMING],
  [EventStatus.FIRST_HALF, EventStatusString.FIRST_HALF],
  [EventStatus.FIRST_HALF_PAUSE, EventStatusString.FIRST_HALF_PAUSE],
  [EventStatus.SECOND_HALF, EventStatusString.SECOND_HALF],
  [EventStatus.SECOND_HALF_PAUSE, EventStatusString.SECOND_HALF_PAUSE],
  [EventStatus.OT_FIRST_HALF, EventStatusString.OT_FIRST_HALF],
  [EventStatus.OT_FIRST_HALF_PAUSE, EventStatusString.OT_FIRST_HALF_PAUSE],
  [EventStatus.OT_SECOND_HALF, EventStatusString.OT_SECOND_HALF],
  [EventStatus.PENALTY_SHOOTOUT, EventStatusString.PENALTY_SHOOTOUT],
  [EventStatus.POST_GAME, EventStatusString.POST_GAME],
  [EventStatus.ABORTED, EventStatusString.ABORTED],
  [EventStatus.CANCELLED, EventStatusString.CANCELLED],
  [EventStatus.ENDED, EventStatusString.EVENT_CLOSED],
  [EventStatus.RUNNING, EventStatusString.RUNNING],
  [EventStatus.HT_RUNNING, EventStatusString.HT_RUNNING],
]);

export const ShortEventStatusStringMap = new Map<
  EventStatus | string,
  ShortEventStatusString
>([
  [EventStatus.UPCOMING, ShortEventStatusString.Upcoming],
  [EventStatus.PREGAME, ShortEventStatusString.Pregame],
  [EventStatus.FIRST_HALF, ShortEventStatusString.FirstHalf],
  [EventStatus.FIRST_HALF_PAUSE, ShortEventStatusString.FirstHalfPause],
  [EventStatus.SECOND_HALF, ShortEventStatusString.SecondHalf],
  [EventStatus.SECOND_HALF_PAUSE, ShortEventStatusString.SecondHalfPause],
  [EventStatus.OT_FIRST_HALF, ShortEventStatusString.OtFirstHalf],
  [EventStatus.OT_FIRST_HALF_PAUSE, ShortEventStatusString.OtFirstHalfPause],
  [EventStatus.OT_SECOND_HALF, ShortEventStatusString.OtSecondHalf],
  [EventStatus.PENALTY_SHOOTOUT, ShortEventStatusString.PenaltyShootout],
  [EventStatus.POST_GAME, ShortEventStatusString.PostGame],
  [EventStatus.ENDED, ShortEventStatusString.PostGame],
  [EventStatus.ABORTED, ShortEventStatusString.Aborted],
  [EventStatus.CANCELLED, ShortEventStatusString.Cancelled],
]);
